import { Card } from 'antd';

const AuditLogs = () => {
  return (
    <Card title="审计日志">
      审计日志页面
    </Card>
  );
};

export default AuditLogs; 